import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Table } from 'react-bootstrap';
import { isEmpty } from 'lodash';

import EmptyTableAlert from '../EmptyTableAlert';
import TablePagination from '../TablePagination';

const ListModal = ({ childProps, children, items, show, title, onHide }) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table responsive borderless size="sm">
          {!isEmpty(items) ? (
            <tbody>{children}</tbody>
          ) : (
            <EmptyTableAlert {...childProps.emptyTableAlertProps} />
          )}
        </Table>
        <TablePagination {...childProps.tablePaginationProps} />
      </Modal.Body>
    </Modal>
  );
};

ListModal.propTypes = {
  childProps: PropTypes.shape({
    emptyTableAlertProps: PropTypes.shape({
      message: PropTypes.string.isRequired,
      numberOfColumns: PropTypes.number.isRequired
    }),
    tablePaginationProps: PropTypes.shape({
      currentPage: PropTypes.number,
      isPaginationOn: PropTypes.bool.isRequired,
      itemsPerPage: PropTypes.number,
      totalCount: PropTypes.number,
      changePage: PropTypes.func
    })
  }).isRequired,
  children: PropTypes.node.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onHide: PropTypes.func.isRequired
};

export default ListModal;
